import styled from 'styled-components'
import Fonts, { family } from 'components/base-ui/Fonts'
import { Button } from 'components/base-ui'

const Wrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.primary};
`

const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.XS};
  background: ${({ theme }) => theme.colors.primary};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`

const Profile = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.XS};
`

const ProfileImage = styled.img`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  border: 2px solid ${({ theme }) => theme.colors.white};

  @media (max-width: 360px) {
    width: 32px;
    height: 32px;
  }
`

const Title = styled(Fonts.BaseBold)`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-family: ${family.brand};
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: 360px) {
    font-size: ${({ theme }) => theme.fontSize.md};
  }
`

const Description = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.white};
  @media (max-width: 360px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`

const MembershipCard = styled.img`
  height: 40px;
  width: 60px;
  border: 1px solid #fff;
  border-radius: ${({ theme }) => theme.radius.sm};

  @media (max-width: 360px) {
    height: 35px;
    width: 55px;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.XS};

  @media (max-width: 360px) {
    padding: ${({ theme }) => theme.spacing['2XS']};
  }
`

const PrivilegeButton = styled(Button)`
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: ${({ theme }) => theme.spacing['2XS']} ${({ theme }) => theme.spacing.XL};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  min-height: 22px;
  height: fit-content;
  width: auto;

  @media (max-width: 360px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
    padding: ${({ theme }) => theme.spacing['3XS']} ${({ theme }) => theme.spacing.M};
  }
`

const PrivilegeText = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.primary};
  @media (max-width: 360px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`

const CouponDesc = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing['3XS']};
`

export {
  Wrapper,
  Detail,
  Profile,
  ProfileImage,
  Title,
  Description,
  Footer,
  MembershipCard,
  PrivilegeButton,
  PrivilegeText,
  CouponDesc,
}
